import { render, staticRenderFns } from "./ParametersItems.vue?vue&type=template&id=13dd8f2b&scoped=true"
import script from "./ParametersItems.vue?vue&type=script&lang=ts"
export * from "./ParametersItems.vue?vue&type=script&lang=ts"
import style0 from "./ParametersItems.vue?vue&type=style&index=0&id=13dd8f2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd8f2b",
  null
  
)

export default component.exports